import { Injectable } from '@angular/core';

import { StorageService } from './storage';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    constructor(private storageService: StorageService) {}

    recordEvent(collection: string, metadata?: {}) {}
}
